import {fab} from '@fortawesome/free-brands-svg-icons'
import {far} from '@fortawesome/free-regular-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {library} from '@fortawesome/fontawesome-svg-core'
import moment from 'moment'
import React, {useState} from 'react'
import {createBrowserRouter, Navigate} from 'react-router'
import {RouterProvider} from 'react-router/dom'
import 'moment/locale/fr'

import {NeedHelp} from './components/ui/chat/NeedHelp'
import AuthAPI from './services/AuthAPI'
import AuthContext from './contexts/AuthContext'
import CartContextProvider from './contexts/CartContext'
import LoginFormEditPassword from './components/pages/login/LoginFormEditPassword.tsx'
import {MenuProvider} from './providers/MenuProvider'
import {PRIVATES_ROUTES} from './router/routes/privateRoutes'
import {ADMIN_ROUTES} from './router/routes/adminRoutes'

import './App.scss'
import {Matomo} from "./components/ui/matomo/Matomo";
import {EventProvider} from "./providers/EventProvider.tsx";
import {UpdatePassword} from './components/pages/login/UpdatePassword.tsx'
import {LoginFormForgotPassword} from './components/pages/login/LoginFormForgotPassword.tsx'
import {UpdatePasswordInformation} from './components/pages/login/UpdatePasswordInformation.tsx'

const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(
        AuthAPI.isAuthenticated(),
    )
    const [user, setUser] = useState(AuthAPI.getUser())

    moment.locale('fr')

    // Font Awesome 5 React Library
    library.add(fab, fas, far)

    // if (globalThis.localStorage.getItem('authToken')) {}

    return (
        <div className="App bg-white-dark">
            <MenuProvider>
                <AuthContext.Provider
                    value={{
                        isAuthenticated,
                        setIsAuthenticated,
                        user,
                        setUser,
                    }}>
                    <EventProvider>
                        <NeedHelp/>
                        <Matomo/>
                        <CartContextProvider>
                            <RouterProvider
                                router={createBrowserRouter([
                                    PRIVATES_ROUTES.addRoutes(ADMIN_ROUTES).serialize(),
                                    {
                                        path: '/nouveau-mot-de-passe',
                                        element: <LoginFormEditPassword/>,
                                    },
                                    {
                                        path: '/changement-mot-de-passe',
                                        element: <UpdatePassword />,
                                    },
                                    {
                                        path: '/changement-mot-de-passe-information',
                                        element: <UpdatePasswordInformation />,
                                    },
                                    {
                                        path: '/forgot-password',
                                        element: <LoginFormForgotPassword />
                                    },
                                    {
                                        path: '/v2*',
                                        element: <Navigate to={'/'}/>,
                                    },
                                    {
                                        path: '*',
                                        element: <Navigate to={'/'}/>,
                                    },
                                ], {
                                    future: {
                                        v7_relativeSplatPath: true,
                                        v7_fetcherPersist: true,
                                        v7_normalizeFormMethod: true,
                                        v7_partialHydration: true,
                                        v7_skipActionErrorRevalidation: true,
                                    }
                                })}
                                future={{
                                    v7_startTransition: true,
                                }}
                            />
                        </CartContextProvider>
                    </EventProvider>
                </AuthContext.Provider>
            </MenuProvider>
        </div>
    )
}

export default App
